import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import css from "./CommentsList.module.css";
import { saveCommentsData } from "../../actions/bcfData";
import { cubeView, getCubeViewSnapshot } from "../../services/cubeView";
import cloneObject from "../../services/cloneObject";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import RichTextEditorComponent from "../../cubeComponent/form/RichTextEditorComponent";
import { HoopsViewerContext } from "../Viewer/ViewerContext";
import UserNameTagComponent from "../../cubeComponent/html/UserNameTagComponent";
import { useTranslation } from "react-i18next";

function CommentsAdd(props) {
  const { t } = useTranslation();
  const { viewerImpl } = useContext(HoopsViewerContext);
  const dispatch = useDispatch();

  const [commentTitle, setCommentTitle] = useState("");
  const [commentSnapshot, setCommentSnapshot] = useState("");
  const [commentViewpoint, setCommentViewpoint] = useState("");
  const [bcfData, setBcfData] = useState("");
  const userDetails = useSelector((state) => state.userDetails);
  const [postBtnEnabled, setPostBtnEnabled] = useState(false);

  const createdByName = {
    firstName: userDetails.firstName.charAt(0).toUpperCase() + userDetails.firstName.slice(1).toLowerCase(),
    lastName: userDetails.lastName?.charAt(0).toUpperCase() + userDetails.lastName?.slice(1).toLowerCase() || "",
  };

  const insertImageSettings = { saveFormat: "Base64", display: "inline" };

  const getUserAvatar = (id) => {
    return <UserNameTagComponent showAvatarOnly id={id} size="LSM" isCircle />;
  };

  const handleIssueViewPoint = async () => {
    let bcfData = await Communicator.BCFViewpoint.createViewpoint(hwv, "viewpoint.bcfv");
    delete bcfData._viewer;
    bcfData = cloneObject(bcfData);
    setBcfData(JSON.stringify(bcfData));

    const viewpoint = await cubeView.toJson(viewerImpl);
    setCommentViewpoint(JSON.stringify(viewpoint));
  };

  const handleTakeSnapshot = async () => {
    const snapshot = await getCubeViewSnapshot();
    setCommentSnapshot(snapshot);
    handleIssueViewPoint();
  };

  const handleCommentDescriptionChange = (args) => {
    setCommentTitle(args.value);
    if (args.value?.length > 0) {
      const html = args.value;
      const div = document.createElement("div");
      div.innerHTML = html;
      const text = div.textContent || div.innerText || "";
      if (text.trim() != "") {
        setPostBtnEnabled(true);
      }
    } else {
      setPostBtnEnabled(false);
    }
  };

  const handleCancelComment = () => {
    props.handleAddComment(props.issueIndex);
    props.handelShowAddComment(false);
  };

  const handleCreateComment = () => {
    const savedData = {
      fileId: props?.fileVersionId,
      title: commentTitle,
      issueId: props.issueId,
      snapshot: commentSnapshot,
      viewpoint: commentViewpoint,
      bcfData,
    };
    const userData = {
      createdBy: userDetails.id,
      createdByName: createdByName.lastName
        ? `${createdByName.firstName} ${createdByName.lastName}`
        : createdByName.firstName,
      createdByProfilePic: userDetails.profilePic,
    };
    dispatch(saveCommentsData(savedData, userData));
    props.handleAddComment(props.issueIndex);
    props.handelShowAddComment(false);
  };

  useEffect(() => {
    if (!props.pdfViewer && !props.issueIsStandalone) {
      handleTakeSnapshot();
    }
  }, []);

  return (
    <div className={css.parentDivCmnt}>
      <div className={css.subDivCmnt}>
        <div className={css.profileImgDiv}>{getUserAvatar(userDetails.id, userDetails.profilePic)}</div>
        <div className={css.commentsMetadata}>
          <span className={css.subCommentsMetadata}>
            <span className={css.commentsUserName}>{`${createdByName.firstName} ${createdByName.lastName}`}</span>
          </span>
        </div>
      </div>
      <div className={css.addCommentsDetailsDiv}>
        <div className="mainComment">
          <RichTextEditorComponent
            toolbarSettings={{
              items: ["Bold", "Italic", "Underline", "Alignments", "Outdent", "Indent"],
            }}
            id={css.oneditForRichText}
            change={handleCommentDescriptionChange}
            value={commentTitle}
            saveInterval={1}
            showCharCount={false}
            toolbarBgColor="#f0f5f9"
            insertImageSettings={insertImageSettings}
          />
          <div className={css.addCommentButtons}>
            <ButtonComponent
              buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
              onClick={handleCreateComment}
              disabled={!postBtnEnabled}
            >
              {t("Post")}
            </ButtonComponent>
            <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={handleCancelComment}>
              {t("Cancel")}
            </ButtonComponent>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommentsAdd;
